export default __webpack_public_path__ + "47810e6a84e3b4cf74c746ddeea28d04.png";